export default class Sizer {
    constructor(container, widget, callback) {
        this.container = container;
        this.widget = widget;
        this.callback = callback;
        this.resizeHandler = this.onWindowResize.bind(this);
        window.$(window).resize(this.resizeHandler);
        this.adjustSize();
    }

    clear() {
        window.$(window).off('resize', this.resizeHandler);
    }

    onWindowResize() {
        this.adjustSize();
        setTimeout(this.adjustSize.bind(this), 100);
    }

    adjustSize() {
        const {container, widget} = this;
        let width = window.$(container).innerWidth();
        let height = window.$(window).innerHeight() - 45;
        if (widget)
            window.$(widget).css({width, height});
        if (this.callback)
            this.callback(width, height);
    }
}

export function createGridResizer(el, widgetWidth){
    setInterval(() => {
        let height = window.$(window).innerHeight() - 45;
        let width = window.$(window).innerWidth() < widgetWidth ? window.$(window).innerWidth() : widgetWidth;
        window.$(el.refs.grid.componentSelector).jqxGrid({height, width});
    }, 500);
    // return function resizer(){
    //     // let lastCall;
    //     let self = el;
    //     let height = window.$(window).innerHeight() - 45;
    //     // if(!self.resizeRollback){
    //     //     clearTimeout(lastCall);
    //     //     self.resizeRollback = true;
    //     //     resize();
    //     //     setTimeout(() => {
    //     //         self.resizeRollback = false;
    //     //         lastCall = setTimeout(() => {
    //     //             resize();
    //     //         }, 50);
    //     //     }, 50);
    //     // }
    //     //
    //     // function resize(){
    //
    //     // }
    // }
}

export function onResize(){

}


// WEBPACK FOOTER //
// ./src/utils/Sizer.js